import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles'; // Import ThemeProvider
import Menu from './components/Menu';
import Login from './components/Login';
import Register from './components/Register';
import Home from './components/Home'
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Contacts from './components/Contacts';
import MyMenu from './components/MyMenu';
import theme from './theme'; // Import the theme file
import PasswordResetPage from './components/PasswordResetPage';
import './App.css';
import Footer from './components/Footer';

const App = () => {
  const [authHeaders, setAuthHeaders] = useState(null);
  const backEnd = 'https://api.smartval.bg/api/' 
    // const backEnd = 'http://127.0.0.1:5000/';

  return (
    <ThemeProvider theme={theme}>
      <Router basename="/app">
        <Menu authHeaders={authHeaders} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/login" element={<Login setAuthHeaders={setAuthHeaders} backEnd={backEnd} />} />
          <Route path="/register" element={<Register setAuthHeaders={setAuthHeaders} backEnd={backEnd} />} />
          <Route path="/reset/:token" element={<PasswordResetPage backEnd={backEnd}  /> } />
          <Route
            path="/my-menu"
            element={authHeaders ? <MyMenu user={authHeaders} backEnd={backEnd} /> : <Navigate to="/login" />}
          />
        </Routes>
      </Router>
      <Footer />
    </ThemeProvider>
    
  );
};

export default App;